import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { TransactionRow } from "./TransactionRow";
import { TransactionApiItem } from "store/userTransaction/userTransactionType";

export const TransactionGroup: React.FC<{
  title: string;
  items: TransactionApiItem[];
}> = ({ title, items }) => {
  return (
    <Box>
      <Box
        px={3}
        py={2}
        bg="gray.50"
        borderTopWidth="1px"
        borderBottomWidth="1px"
        borderColor="blackAlpha.100"
      >
        <Text fontSize="sm" fontWeight="bold" color="gray.700">
          {title}
        </Text>
      </Box>

      <Box bg="white">
        {items.map((tx) => (
          <TransactionRow key={tx.bbpsBillPaymentId} tx={tx} />
        ))}
      </Box>
    </Box>
  );
};
